import type { NextPage } from "next";
import Head from "next/head";
import { BrandSlider } from "../components/brandSlider";
import { H1 } from "../components/common/h1";
import { Statistic } from "../components/common/statistic";
/* import { H2 } from "../components/common/h2";
import { VerticalText } from "../components/common/verticalText";
import { ContactForm } from "../components/form/contactForm"; */
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { breakpoints, mq } from "../styles/mq";
import { motion } from "framer-motion";

const About: NextPage = () => {
	const ProjectStats = styled("section")`
		display: grid;
		grid-template-columns: repeat(1, 1fr);
		grid-column-gap: 50px;
		text-align: center;
		margin: 0 auto;
		max-width: 1100px;

		${mq(breakpoints.xl)} {
			grid-template-columns: repeat(3, 1fr);
		}
	`;

	/* const FormContainer = styled("div")`
		position: relative;
		.vertical-text-container {
			position: absolute;
			transform-origin: right;
			top: 100%;
			right: 3%;
			white-space: nowrap;
		}
	`; */

	return (
		<>
			<Head>
				<title>About – Moonsworth</title>
			</Head>
			<main>
				<motion.div
					initial={{ opacity: 0, y: -50 }}
					animate={{
						opacity: 1,
						y: 0,
					}}
					transition={{
						duration: 0.8,
						delay: 0.2,
						type: "spring",
						bounce: 0,
					}}
				>
					<H1
						tagline="Here’s some stats"
						styles={css`
							text-align: center;
							max-width: 800px;
							padding: 30px;
						`}
					>
						Let our numbers do the talking
					</H1>
				</motion.div>
				<ProjectStats>
					<motion.div
						initial={{ opacity: 0, y: -50 }}
						animate={{
							opacity: 1,
							y: 0,
						}}
						transition={{
							duration: 0.8,
							delay: 0.5,
							type: "spring",
							bounce: 0,
						}}
					>
						<Statistic
							figure="750K"
							description="Social Media Followers"
							secondary
						/>
					</motion.div>
					<motion.div
						initial={{ opacity: 0, y: -50 }}
						animate={{
							opacity: 1,
							y: 0,
						}}
						transition={{
							duration: 0.8,
							delay: 0.4,
							type: "spring",
							bounce: 0,
						}}
					>
						<Statistic figure="2M" description="Monthly Users" />
					</motion.div>
					<motion.div
						initial={{ opacity: 0, y: -50 }}
						animate={{
							opacity: 1,
							y: 0,
						}}
						transition={{
							duration: 0.8,
							delay: 0.7,
							type: "spring",
							bounce: 0,
						}}
					>
						<Statistic
							figure="17.5M"
							description="Downloads"
							secondary
						/>
					</motion.div>
				</ProjectStats>

				<BrandSlider />

				{/* <FormContainer>
					<H2
						styles={{
							textAlign: "center",
							maxWidth: "800px",
							padding: "30px",
							marginTop: "150px",
						}}
						description={
							"Use the form below to contact us about anything and everything! Whether it's a potential business opportunity or a press-related inquiry, we would  love to hear from you!"
						}
					>
						Want to work <span>with us</span>?
					</H2>
					<ContactForm />
					<VerticalText text="Message us" />
				</FormContainer> */}
			</main>
		</>
	);
};

export default About;
